import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectScopedJobIds,
  selectScopeJobs,
  selectScopeJobsLoaded,
  selectScopeJobsLoading,
  toggleJob,
  selectAll,
  openDropdown,
  fetchJobsForScope,
} from "../../redux/slices/job-scope-slice";

export default function ScopedOnly({ children }) {
  const dispatch = useDispatch();
  const scope = useSelector(selectScopedJobIds);
  const jobs = useSelector(selectScopeJobs);
  const loaded = useSelector(selectScopeJobsLoaded);
  const loading = useSelector(selectScopeJobsLoading);

  useEffect(() => {
    if (!loaded && !loading) dispatch(fetchJobsForScope());
  }, [dispatch, loaded, loading]);

  if (scope.length > 0) return children;

  return (
    <div className="text-center py-16 px-6 bg-white border border-dashed border-slate-200 rounded-xl">
      <div className="w-12 h-12 rounded-xl bg-vf-tint text-vf-primary flex items-center justify-center text-2xl mx-auto mb-3">
        ⚠
      </div>
      <h3 className="text-base font-medium text-vf-base mb-2">
        Select one or more jobs to continue
      </h3>
      <p className="text-sm text-vf-muted max-w-md mx-auto mb-4">
        Source, Interview, Compare, and Hire stages show data for jobs you scope.
        Pick the positions you're working on to populate this screen.
      </p>
      <div className="flex gap-2 justify-center flex-wrap">
        {jobs.slice(0, 3).map((j) => (
          <button
            key={j.id}
            onClick={() => dispatch(toggleJob(j.id))}
            className="px-3 py-1.5 rounded border border-slate-300 text-xs text-vf-base hover:bg-vf-tint hover:border-vf-primary"
          >
            {j.name || "Untitled job"}
          </button>
        ))}
        {jobs.length > 0 && (
          <button
            onClick={() => dispatch(selectAll(jobs.map((j) => j.id)))}
            className="px-3 py-1.5 rounded bg-vf-primary text-white text-xs hover:bg-vf-primary"
          >
            Select all {jobs.length} jobs
          </button>
        )}
        <button
          onClick={() => dispatch(openDropdown())}
          className="px-3 py-1.5 rounded border border-dashed border-vf-primary text-xs text-vf-primary hover:bg-vf-tint"
        >
          + Open scope picker
        </button>
      </div>
      {loading && (
        <p className="text-xs text-vf-muted mt-3">Loading your jobs…</p>
      )}
    </div>
  );
}
